var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGladshare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 72,
    viewBox: "0 0 65 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8 47.428C19.8 40.0334 19.8 32.6388 19.8 25.2442C20.9824 25.2088 22.1647 25.2088 23.347 25.1734C23.347 24.0059 23.347 22.803 23.347 21.6353C30.3714 21.6353 37.361 21.6353 44.3854 21.6C44.3854 23.8644 44.3506 26.1641 44.3506 28.4285C39.3432 28.6054 34.3357 28.7823 29.3282 28.9592C29.3282 33.3111 29.3282 37.6629 29.2934 42.0147C31.7623 41.767 34.1966 41.484 36.6655 41.2363C36.6655 39.6088 36.6655 37.9813 36.6655 36.3538C39.2041 36.1769 41.7426 35.9646 44.2811 35.8231C44.2811 39.715 44.2464 43.5715 44.2464 47.4634C37.2567 48.3125 30.2671 49.3032 23.3122 50.4C23.3122 49.2324 23.3122 48.0294 23.3122 46.8619C22.1299 47.1096 20.9476 47.2865 19.8 47.428Z",
    fill: "#38B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0623 2.85751L60.2623 17.1375C61.9543 18.0963 63.0001 19.8908 63.0001 21.8356V50.1643C63.0001 52.1091 61.9543 53.9036 60.2623 54.8625L35.0623 69.1424C33.4109 70.0783 31.3892 70.0783 29.7378 69.1424L4.53778 54.8625C2.84579 53.9036 1.80005 52.1091 1.80005 50.1643V21.8356C1.80005 19.8908 2.84578 18.0963 4.53778 17.1375L29.7378 2.85752C31.3892 1.92168 33.4109 1.92168 35.0623 2.85751Z",
    stroke: "#38B6FF",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.8,
    height: 72,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGladshare);
export default __webpack_public_path__ + "static/media/gladshare.1ff51490d67c244f8495a6836936e311.svg";
export { ForwardRef as ReactComponent };